import type { ThunkDispatch } from '@ms/yammer-data/dist/types';
import type { YammerTeamsNativeState } from 'state/types';

export const lazySetUpDiagnosticsDebugLogging = async (getState: () => YammerTeamsNativeState): Promise<void> => {
  const module = await import(/* webpackChunkName: "4-feat-set-up-debug-logging" */ './setUpDiagnosticsDebugLogging');

  module.setUpDiagnosticsDebugLogging(getState);
};

export const lazyPreloadPageData = async (
  dispatch: ThunkDispatch<YammerTeamsNativeState>,
  getState: () => YammerTeamsNativeState
): Promise<void> => {
  const module = await import(/* webpackChunkName: "4-feat-preload-page-data" */ './preloadPageData');

  module.preloadPageData(dispatch, getState);
};

export const lazyInvokePostRenderActions = async (getState: () => YammerTeamsNativeState): Promise<void> => {
  const module = await import(
    /* webpackChunkName: "4-feat-post-render-bootstrap-actions" */ './invokePostRenderActions'
  );

  module.invokePostRenderActions(getState);
};
